// extracted by mini-css-extract-plugin
export default {"xAxis":"useChartConfig_xAxis__7MVBS","tooltipDate":"useChartConfig_tooltipDate__RZPY9"};